import { useParams } from 'react-router-dom';
import { useQuoteDispatch, useQuoteState } from '../../stateProviders/QuoteStateProvider';
import { useEffect, useMemo, useRef } from 'react';
import { useApi } from '../../hooks/useApi';
import { useGlobalState } from '../../stateProviders/GlobalStateProvider';
import { DrawSpace } from '../quotations/views/OptionSelection/components/DeckBoxBuilder/components/DrawSpace';

export const PrintQuote = () => {
    const { quoteId } = useParams();
    const quoteState = useQuoteState();
    const api = useApi()
    const quoteDispatch = useQuoteDispatch();
    const globalState = useGlobalState();
    const downloadButtonRef = useRef<HTMLButtonElement>(null)

    useEffect( () => {
        if(quoteState.currentQuote || !quoteId) return
        (async () => {
            const quote = await api.quotations.getQuotationById(quoteId);
            quoteDispatch({currentQuote:quote})
        })()
    },[quoteId,quoteState.currentQuote])

    const subtotal = useMemo( () => {
        if(!quoteState.currentQuote) return 0
        const subtotal = Object.values(quoteState.currentQuote.materialCost).reduce( (acc:any, cost:any) => {
            return parseFloat(acc) + parseFloat(cost)
        },0)
        return subtotal
    },[quoteState.currentQuote])

    return (
        <div className='p-[50px] h-full flex flex-col'>
            <div className='flex justify-between'>
                <div className='p-[10px] bg-[grey] rounded border'>
                    <img src={globalState.company?.profilePicture || ''} alt='logo' className='w-[200px]'/>
                </div>
                <div className='flex flex-col'>
                    <p>Id: {quoteId}</p>
                    <p>Date: {quoteState.currentQuote?.createdDate ? new Date(quoteState.currentQuote.createdDate).toLocaleDateString() : 'N/A'}</p>
                    <p>Customer Name: {quoteState.currentQuote?.customerName}</p>
                </div>
            </div>
            <div className='py-[20px]'>
                <p>Subtotal: ${subtotal}</p>
                <p>Sales Tax: ${(subtotal * 0.07).toFixed(2)}</p>
                <p>Total: ${(subtotal + subtotal * 0.07).toFixed(2) }</p>
                <button 
                    ref={downloadButtonRef}
                    onClick={() => {
                        // Get the <g> element directly nested inside the <svg> element
                        const svgElement = document.getElementById('drawspace');
                        if(!svgElement) return
                        const gElement = svgElement.querySelector('g');
                        if(!gElement) return
                        
                        // Get the bounding box of the <g> element
                        const bbox = gElement.getBBox();
                        
                        // Create a new <svg> element
                        const newSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
                        newSvg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
                        
                        // Set dynamic width and height based on the bounding box
                        const width = bbox.width;
                        const height = bbox.height;
                        newSvg.setAttribute('width', width.toString());
                        newSvg.setAttribute('height', height.toString());
                        
                        // Set the viewBox dynamically based on the bounding box
                        newSvg.setAttribute('viewBox', `${bbox.x} ${bbox.y} ${width} ${height}`);
                        const newGElement = gElement.cloneNode(true) as SVGElement
                        newGElement.setAttribute('transform', '');
                        // Append the cloned <g> element to the new <svg>
                        newSvg.appendChild(newGElement); // Clone the <g> element to avoid removing it
                        
                        // Serialize the new <svg> to a string
                        const svgData = new XMLSerializer().serializeToString(newSvg);
                        
                        // Create a Blob from the SVG data
                        const svgBlob = new Blob([svgData], { type: 'image/svg+xml;charset=utf-8' });
                        
                        // Create a URL for the Blob
                        const svgUrl = URL.createObjectURL(svgBlob);
                        
                        // Create a download link
                        const downloadLink = document.createElement('a');
                        downloadLink.href = svgUrl;
                        downloadLink.download = 'g-shape-dynamic.svg'; // Specify the file name
                        
                        // Trigger the download
                        document.body.appendChild(downloadLink);
                        downloadLink.click();
                        
                        // Clean up
                        document.body.removeChild(downloadLink);
                    }}
                >
                    Download
                </button>
            </div>
            <DrawSpace/>
        </div>
    );
}